/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseListManageTicketTags } from '../models/api-response-list-manage-ticket-tags';
import { ApiResponseManageTicketTags } from '../models/api-response-manage-ticket-tags';
import { ApiResponsePageManageTicketTags } from '../models/api-response-page-manage-ticket-tags';
import { createTags } from '../fn/manage-ticket-tags-api/create-tags';
import { CreateTags$Params } from '../fn/manage-ticket-tags-api/create-tags';
import { getAllTags } from '../fn/manage-ticket-tags-api/get-all-tags';
import { GetAllTags$Params } from '../fn/manage-ticket-tags-api/get-all-tags';
import { getTagsByRef } from '../fn/manage-ticket-tags-api/get-tags-by-ref';
import { GetTagsByRef$Params } from '../fn/manage-ticket-tags-api/get-tags-by-ref';
import { searchTags } from '../fn/manage-ticket-tags-api/search-tags';
import { SearchTags$Params } from '../fn/manage-ticket-tags-api/search-tags';
import { updateTags } from '../fn/manage-ticket-tags-api/update-tags';
import { UpdateTags$Params } from '../fn/manage-ticket-tags-api/update-tags';

@Injectable({ providedIn: 'root' })
export class ManageTicketTagsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateTags()` */
  static readonly UpdateTagsPath = '/v1/api/ui/manage-ticket-tags/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTags()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTags$Response(params: UpdateTags$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseManageTicketTags>> {
    return updateTags(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTags$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTags(params: UpdateTags$Params, context?: HttpContext): Observable<ApiResponseManageTicketTags> {
    return this.updateTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseManageTicketTags>): ApiResponseManageTicketTags => r.body)
    );
  }

  /** Path part for operation `searchTags()` */
  static readonly SearchTagsPath = '/v1/api/ui/manage-ticket-tags/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTags()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTags$Response(params: SearchTags$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePageManageTicketTags>> {
    return searchTags(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTags$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTags(params: SearchTags$Params, context?: HttpContext): Observable<ApiResponsePageManageTicketTags> {
    return this.searchTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePageManageTicketTags>): ApiResponsePageManageTicketTags => r.body)
    );
  }

  /** Path part for operation `createTags()` */
  static readonly CreateTagsPath = '/v1/api/ui/manage-ticket-tags/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTags()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTags$Response(params: CreateTags$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseManageTicketTags>> {
    return createTags(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createTags$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTags(params: CreateTags$Params, context?: HttpContext): Observable<ApiResponseManageTicketTags> {
    return this.createTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseManageTicketTags>): ApiResponseManageTicketTags => r.body)
    );
  }

  /** Path part for operation `getTagsByRef()` */
  static readonly GetTagsByRefPath = '/v1/api/ui/manage-ticket-tags/get/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTagsByRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTagsByRef$Response(params: GetTagsByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseManageTicketTags>> {
    return getTagsByRef(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTagsByRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTagsByRef(params: GetTagsByRef$Params, context?: HttpContext): Observable<ApiResponseManageTicketTags> {
    return this.getTagsByRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseManageTicketTags>): ApiResponseManageTicketTags => r.body)
    );
  }

  /** Path part for operation `getAllTags()` */
  static readonly GetAllTagsPath = '/v1/api/ui/manage-ticket-tags/all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllTags()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTags$Response(params?: GetAllTags$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListManageTicketTags>> {
    return getAllTags(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllTags$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllTags(params?: GetAllTags$Params, context?: HttpContext): Observable<ApiResponseListManageTicketTags> {
    return this.getAllTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListManageTicketTags>): ApiResponseListManageTicketTags => r.body)
    );
  }

}
